import { render, staticRenderFns } from "./UapsBudgetAddmainForm.vue?vue&type=template&id=75fc9799&scoped=true"
import script from "./UapsBudgetAddmainForm.vue?vue&type=script&lang=js"
export * from "./UapsBudgetAddmainForm.vue?vue&type=script&lang=js"
import style0 from "./UapsBudgetAddmainForm.vue?vue&type=style&index=0&id=75fc9799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fc9799",
  null
  
)

export default component.exports